export interface DeliveryAddress {
  post_code: string;
  city: string;
  country: string;
  street: string;
  street_number: string;
}
